<template>
<div class="comment-modal" v-if="isModalShow">
  <component :is="modalName"></component>
  <div class="comment-modal__bg" @click="hideModal"></div>
</div>
</template>

<script>
import modalDelete from './modalDelete.vue'
import modalError from './modalError.vue'
import modalReport from './modalReport.vue'
// import modalLogin from './modalLogin.vue'
// import modalRank from './modalRank.vue'

import { mapState, mapMutations } from 'vuex'

export default {
  name: 'modal',
  computed: {
    ...mapState('modal', ['isModalShow', 'modalName'])
  },
  components: {
    modalError,
    modalDelete,
    modalReport
    // modalLogin,
    // modalRank
  },
  methods: {
    ...mapMutations('modal', ['hideModal'])
  }
}
</script>

<style lang="scss" src="./modal.scss"></style>



// WEBPACK FOOTER //
// src/components/molecules/modal/modal.vue